<template>
  <el-container class="layout_basic">
    <el-header style="background-color:#2778cc;">
      <el-row>
        <el-col :span='8' style="height: 60px; line-height: 60px;">
          <span style="color: rgb(255, 255, 255); font-size: 18px; text-shadow: 0px 0px 5px;">科普科幻作文大赛后台管理系统</span>
        </el-col>
        <el-col :span="16">
          <el-menu v-if="isBj" style="float: right" :default-active="activeIndex" mode="horizontal" router background-color='#2778cc' text-color='#fff' active-text-color='#cecece' active-background-color='#1f60a3'>
            <el-menu-item index="/home/teacher">老师列表</el-menu-item>
            <el-submenu index="student">
              <template slot="title">学生列表</template>
              <el-menu-item index="/home/person">个人报名</el-menu-item>
              <el-menu-item index="/home/team">团体报名</el-menu-item>
              
            </el-submenu>
            <el-menu-item index="/home/work/award">获奖查询</el-menu-item>
            <el-submenu index="mine">
              <template slot="title">我的</template>
              <el-menu-item index="" @click="modifyPassword">密码修改</el-menu-item>
              <el-menu-item index="" @click="logout">退出</el-menu-item>
            </el-submenu>
          </el-menu>

          <el-menu v-else-if="isBiz" style="float: right" default-active="/home/view" mode="horizontal" router background-color='#2778cc' text-color='#fff' active-text-color='#cecece' active-background-color='#1f60a3'>
            <el-menu-item index="/home">首页</el-menu-item>
            <el-menu-item index="/home/teacher">老师列表</el-menu-item>
            <el-submenu index="mine">
              <template slot="title">我的</template>
              <el-menu-item index="" @click="modifyPassword">密码修改</el-menu-item>
              <el-menu-item index="" @click="logout">退出</el-menu-item>
            </el-submenu>
          </el-menu>

          <el-menu v-else-if="isJudge" style="float: right" default-active="/home/view" mode="horizontal" router background-color='#2778cc' text-color='#fff' active-text-color='#cecece' active-background-color='#1f60a3'>
            <el-menu-item index="/home/view">作品复评</el-menu-item>
            <el-menu-item index="/home/mine">我的评审</el-menu-item>
            <el-submenu index="mine">
              <template slot="title">我的</template>
              <el-menu-item index="" @click="modifyPassword">密码修改</el-menu-item>
              <el-menu-item index="" @click="logout">退出</el-menu-item>
            </el-submenu>
          </el-menu>

          <el-menu v-else style="float: right" :default-active="activeIndex" mode="horizontal" router background-color='#2778cc' text-color='#fff' active-text-color='#cecece' active-background-color='#1f60a3'>
            <el-menu-item index="/home">首页</el-menu-item>
            <el-menu-item index="/home/teacher">老师列表</el-menu-item>
            <el-submenu index="student">
              <template slot="title">学生列表</template>
              <el-menu-item index="/home/person">个人报名</el-menu-item>
              <el-menu-item index="/home/team">团体报名</el-menu-item>
            </el-submenu>
            <el-menu-item index="/home/work/person">作品复评</el-menu-item>
            <el-menu-item index="/home/work/award">获奖查询</el-menu-item>
            <el-menu-item index="/home/award/view">证书预览</el-menu-item>
            <el-submenu index="mine">
              <template slot="title">我的</template>
              <el-menu-item index="" @click="modifyPassword">密码修改</el-menu-item>
              <el-menu-item index="" @click="logout">退出</el-menu-item>
            </el-submenu>
          </el-menu>

        </el-col>
      </el-row>
    </el-header>
    <el-container class="content-flow">
      <router-view></router-view>
    </el-container>

  </el-container>
</template>

<script>

export default {
  name: 'home',
  computed:{
    isJudge(){
      let manager = JSON.parse(sessionStorage.getItem("manager"))
      let roles = this.globalData.judgeRole
      return roles.includes(manager.id)
    },
    isBj(){
      let manager = JSON.parse(sessionStorage.getItem("manager"))
      let roles = this.globalData.bj
      return roles.includes(manager.id)
    },
    isBiz(){
        let manager = JSON.parse(sessionStorage.getItem("manager"))
        let roles = this.globalData.bizRole
        return roles.includes(manager.id)
    }

  },
  data() {
    return {
      activeIndex: '/home'
    }
  },
  methods: {
    modifyPassword() {
      this.$dialog.modifyPassword()
    },
    logout() {
      sessionStorage.clear()
      this.$router.push('/login')
    }
  },
  beforeCreate () {
    let manager = JSON.parse(sessionStorage.getItem("manager"))
    if (!this.globalData.manager) {
      this.$router.push('/login')
    }
    this.globalData.judgeRole = [9, 10, 12, 13, 14, 15]
    if(this.globalData.judgeRole.includes(manager.id)){
      this.$router.push('/home/view')
    }

    this.globalData.bj = [16]
    if(this.globalData.bj.includes(manager.id)){
      this.$router.push('/home/teacher')
    }

    this.globalData.bizRole = [6]

  },
  mounted() {
    this.globalData.provinceOptions = [
      {text: '安徽省', value:'安徽省'},
      {text: '北京市', value:'北京市'},
      {text: '福建省', value:'福建省'},
      {text: '甘肃省', value:'甘肃省'},
      {text: '广东省', value:'广东省'},
      {text: '山东省', value:'山东省'},
      {text: '山西省', value:'山西省'},
      {text: '贵州省', value:'贵州省'},
      {text: '海南省', value:'海南省'},
      {text: '河北省', value:'河北省'},
      {text: '河南省', value:'河南省'},
      {text: '浙江省', value:'浙江省'},
      {text: '黑龙江省', value:'黑龙江省'},
      {text: '湖北省', value:'湖北省'},
      {text: '湖南省', value:'湖南省'},
      {text: '吉林省', value:'吉林省'},
      {text: '江苏省', value:'江苏省'},
      {text: '江西省', value:'江西省'},
      {text: '辽宁省', value:'辽宁省'},
      {text: '青海省', value:'青海省'},
      {text: '陕西省', value:'陕西省'},
      {text: '上海市', value:'上海市'},
      {text: '四川省', value:'四川省'},
      {text: '天津市', value:'天津市'},
      {text: '云南省', value:'云南省'},
      {text: '重庆市', value:'重庆市'},
      {text: '广西壮族自治区', value:'广西壮族自治区'},
      {text: '内蒙古自治区', value:'内蒙古自治区'},
      {text: '宁夏回族自治区', value:'宁夏回族自治区'},
      {text: '西藏自治区', value:'西藏自治区'},
      {text: '新疆维吾尔族自治区', value:'新疆维吾尔族自治区'},
      {text: '澳门特别行政区', value:'澳门特别行政区'}
    ]

    this.globalData.exportRole = [1,2,3]
    
    this.api.district.findList('level=1').then(res => {
      this.globalData.provinceList = res.data
    })
  }
}
</script>
